module.exports = __webpack_public_path__ + "static/media/RE.09748880.svg";